import React from "react";
import JsonLdGeneric, { GenericJsonDataProps } from "../JsonLdGeneric";

/**
 * Returns a component that adds a JSON-LD tag of type Article.
 * @param {String} name
 * @param {String} description
 * @returns {Component}
 * */
const JsonLdArticle = ({ name, description }: GenericJsonDataProps) => {
  const structuredArticleJsonLdData = {
    "@context": "https://schema.org/",
    "@type": "Article",
    name: name || "Good Pair Days",
    headline: name || "Good Pair Days",
    description: description || "Good Pair Days is a personalised monthly wine club.",
    author: {
      "@type": "Organization",
      name: "Good Pair Days",
    },
    "@id": window.location.href,
  };

  return <JsonLdGeneric jsonData={structuredArticleJsonLdData} />;
};

export default JsonLdArticle;
